<template>
  <button class="gmf-cheevo" :class="getCheevoClasses(achievement)">
    <div class="gmf-cheevo-img-col">
      <AchievementImage :achievement="achievement" :showProgress="true" />
      <template v-if="achievement.maxLevel > 1 && isUnlocked">
        <div class="gmf-text-xs gmf-cheevo-level-label">{{ levelProgressionLabel }}</div>
        <MiniLevelTrack :level="trackLevel" :maxLevel="achievement.maxLevel" :levelData="achievement.levelData" />
      </template>
      <!--<div class="gmf-text-xs gmf-xp" style="font-weight: bold;">{{ achievement.tier.name }}</div>-->
      </div>
    <div class="gmf-cheevo-col-desc">
      <div style="display: flex; flex-direction: column; gap: var(--gmf-p-2); flex-grow: 1; justify-content: center">
        <div class="gmf-cheevo-name gmf-subheader">
          {{ name }}
        </div>
        <div class="gmf-cheevo-desc gmf-text-small" v-html="md(achievement.description)"></div>
      </div>
      <div class="gmf-cheevo-rewards" v-if="newNewRewards.length">
        <div class="gmf-reward-list">
          <div class="gmf-reward gmf-text-small" v-for="reward, idx in newNewRewards" :key="idx">{{ reward.quantity + ' ' + (reward.name||reward.type) }}</div>
          <!--<div class="gmf-reward gmf-text-small" v-if="tokens">
            {{ tokens.quantity }}<img :src="tokens.icon" class="gmf-quest-token-icon" />{{ tokens.name }}
          </div>-->
        </div>
      </div>
      <div class="gmf-cheevo-rewards" v-else-if="xp">
        <!--<div class="gmf-text-xs gmf-mb-1" style="font-weight: bold; color: var(--gmf-col-nearblack)">Belöningar:</div>-->
        <div class="gmf-cheevo-reward-list">
          <div v-if="xp" class="gmf-cheevo-reward">
            <Icon v-if="showRewardIcons" icon="point_star" />
            <div class="gmf-text-small">{{ xp.quantity + xp.name }}</div>
          </div>
          <!--<div class="gmf-cheevo-reward gmf-text-small" v-if="tokens">
            {{ tokens.quantity }}<img :src="tokens.icon" class="gmf-quest-token-icon" />{{ tokens.name }}
          </div>-->
        </div>
      </div>
    </div>
    <!--<div class="gmf-cheevo-chevron-right" v-if="!disableDetailsModal" />-->
    
  </button>
</template>

<style>
.gmf-cheevo-list .gmf-cheevo {
  display: flex;
  background: var(--gmf-col-lightgray);
  border-radius: var(--gmf-rounding);
  padding: var(--gmf-p-4);
  align-items: stretch;
  gap: var(--gmf-object-spacing);
  flex-grow: 1;
  width: 400px;
  transition: background 0.1s linear;

  /* Button reset */
  border: none;
}
.gmf-cheevo-list .gmf-cheevo.gmf-cheevo-filler {
  background: red;
  padding: 0;
  visibility: hidden;
}
.gmf-cheevo-list .gmf-achievement-image {
  width: 80px;
  height: 80px;
  flex-grow: 0;
  flex-shrink: 0;
}
.gmf-cheevo-list .gmf-cheevo-name {
  margin: 0 !important;
}
.gmf-cheevo-list .gmf-cheevo-col-desc {
  flex-grow: 1;
  max-width: 100%;
  overflow: hidden;
  display: flex;
  gap: var(--gmf-p-2);
  flex-direction: column;
  justify-content: space-between;
}
.gmf-cheevo-img-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--gmf-p-2);
}
.gmf-cheevo-level {
  display: flex;

  flex-direction: column;

  align-items: center;
  justify-content: center;

  white-space: nowrap;
}


.gmf-cheevo-reward-list {
  display: flex;
  gap: var(--gmf-p-2);
  justify-content: flex-end;
}

.gmf-cheevo-rewards {
  text-align: right;
}

.gmf-cheevo-reward {
  display: flex;
  align-items: center;
  gap: var(--gmf-p-1);
}
</style>

<script>
import md from '@/utils/md';
import state from '@/state';
import AchievementImage from '@/components/AchievementImage.vue';
import MiniLevelTrack from '@/components/MiniLevelTrack.vue';
import advancedString from '@/utils/advancedString';
import Icon from '@/components/Icon';
const t = state.t.prefix('achievements');



export default {
  name: 'AchievementList',
  components: {
    AchievementImage,
    MiniLevelTrack,
    Icon,
  },
  props: {
    achievement: {
      Type: Object,
      required: true,
    },
    disableDetailsModal: {
      Type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      state,
      md,
      t,
    };
  },
  computed: {
    name () {
      let name = this.achievement.name.trim();

      // If ends with - Nivå x or - Level x, etc, remove it
      name = name.replace(/ - (Nivå|Level|Lvl\.|Lv.) \d+$/, '');
      name = name.replace(/(Nivå|Level|Lvl\.|Lv.) \d+$/, '');

      return name.trim();
    },
    isUnlocked () {
      return this.achievement.achievedAt > 0;
    },
    trackLevel () {
      const lv = this.achievement.level;
      if (lv <= 1 && ! this.isUnlocked) {
        return 0;
      }
      return lv;
    },
    levelProgressionLabel () {
      const { level, maxLevel } = this.achievement;

      return advancedString(t('level_progression'), {
        level,
        maxLevel,
      });
    },
    
    newNewRewards() {
      const rewards = this.achievement?.newNewRewards || [];

      const rewardMap = {};
      for (const reward of rewards) {
        if (! rewardMap[reward.type]) {
          rewardMap[reward.type] = reward;
        } else {
          rewardMap[reward.type].quantity += reward.quantity;
        }
      }

      const remappedAchievements = Object.values(rewardMap);
      for (const reward of remappedAchievements) {
        reward.name = reward.name || state.t(this.getRewardTypeTranslationKey(reward.type, reward.quantity));
      }
      return remappedAchievements
    },
    xp () {
      const r = this.achievement.newRewards || this.achievement.rewards;

      const xp = r.xp || r.ip;

      if (typeof xp === 'object') {
        return {
          quantity: xp.quantity,
          name: state.t('xp'),
        }
      }

      // Xp is a number (legacy format for backwards compatibility)
      if (typeof xp === 'number') {
        return {
          quantity: xp,
          name: state.t('xp'),
        };
      }

      return null;
    },
    showRewardIcons () {
      return state.merchantConfig.achievements?.showRewardIcons || false;
    },
  },
  methods: {
    getRewardTypeTranslationKey(type, quantity) {
      if (type === 'xp') {
        return 'xp';
      } else if (type === 'avatar-3d-part') {
        return 'loot_crates.avatar_part' + (quantity > 1 ? '_plural' : '');
      }

      return '';
    },

    getCheevoClasses(achievement) {
      const classes = {
        'gmf-cheevo-achieved': this.isUnlocked,
        'gmf-clickable': ! this.disableDetailsModal,
      };

      if (achievement.tier) {
        classes['gmf-cheevo-tier-' + achievement.tier.level] = true;
      }

      return classes;
    },
  },
  
};
</script>